var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#0F5EFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9102 9.75H8.91016C8.7444 9.75 8.58542 9.81585 8.46821 9.93306C8.351 10.0503 8.28516 10.2092 8.28516 10.375V21C8.28516 21.3315 8.41685 21.6495 8.65127 21.8839C8.88569 22.1183 9.20364 22.25 9.53516 22.25H23.2852C23.6167 22.25 23.9346 22.1183 24.169 21.8839C24.4035 21.6495 24.5352 21.3315 24.5352 21V10.375C24.5352 10.2092 24.4693 10.0503 24.3521 9.93306C24.2349 9.81585 24.0759 9.75 23.9102 9.75ZM16.4102 16.4023L10.5172 11H22.3031L16.4102 16.4023ZM14.1219 16L9.53516 20.2039V11.7961L14.1219 16ZM15.0469 16.8477L15.9844 17.7109C16.0997 17.8168 16.2505 17.8755 16.407 17.8755C16.5636 17.8755 16.7144 17.8168 16.8297 17.7109L17.7672 16.8477L22.2984 21H10.5172L15.0469 16.8477ZM18.6984 16L23.2852 11.7953V20.2047L18.6984 16Z",
    fill: "#0F5EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.a0a1beead6f63d4e208fecc6cb840d9b.svg";
export { ForwardRef as ReactComponent };